import Image from 'next/image';

export const HomeTestimonial = (testimonial: any) => {
  const { description, userImage, userName, userDesignation, userPlace } =
    testimonial;
  return (
    <div className="item">
      <div className="slide-content">
        <svg
          width="22"
          height="16"
          viewBox="0 0 22 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.61626 7.89677C7.46008 8.20645 8.11211 8.70538 8.57237 9.39355C9.07099 10.0473 9.3203 10.8387 9.3203 11.7677C9.3203 13.0065 8.87922 14.0215 7.99705 14.8129C7.11488 15.6043 6.02176 16 4.71768 16C3.3369 16 2.20542 15.6043 1.32325 14.8129C0.441084 14.0215 0 13.0065 0 11.7677C0 11.1484 0.0767103 10.5462 0.230131 9.96129C0.421907 9.37634 0.767103 8.49893 1.26572 7.32903L4.31495 0H8.91757L6.61626 7.89677ZM18.8132 7.89677C19.657 8.20645 20.309 8.70538 20.7693 9.39355C21.2679 10.0473 21.5172 10.8387 21.5172 11.7677C21.5172 13.0065 21.0762 14.0215 20.194 14.8129C19.3118 15.6043 18.2187 16 16.9146 16C15.5338 16 14.4024 15.6043 13.5202 14.8129C12.638 14.0215 12.1969 13.0065 12.1969 11.7677C12.1969 11.1484 12.2736 10.5462 12.4271 9.96129C12.6188 9.37634 12.964 8.49893 13.4627 7.32903L16.5119 0H21.1145L18.8132 7.89677Z"
            fill="#083F8D"
          />
        </svg>
        <blockquote className="text--gray text--regular">
          {description}
        </blockquote>
        <div className="user">
          <Image
            style={{ color: undefined }}
            className="img-fluid"
            src={userImage}
            alt={userName}
          />
          <div className="right">
            <p className="text--black text--bold name">{userName}</p>
            <p className="text--gray text--regular designation">
              {userDesignation},{' '}
              <span className="text--black text--bold">{userPlace}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
